import React from 'react';
import { Marker } from '@react-google-maps/api';

/**
 * Marks a point on the map - only updates when the props change
 * 
 * @returns {JSX.Element}
 * 
 * @category Components - Map
 */
export const MemoizedMarker = React.memo(({ position, icon, title, visible, animation = null, zIndex = 1, label, onClick = null }) => {
  return (
    <Marker
      position={position}
      icon={icon}
      title={title}
      visible={visible}
      animation={animation}
      zIndex={zIndex}
      label={label}
      onClick={onClick}
    />
  );
});
